<!-- start page title -->
<div class="row" style="width: calc(100% + 10px);">
    <div class="page-title-box">
        <div class="page-title-right">
            <button class="btn btn-primary" *ngIf="showButton" (click)="btnClick.emit()">
                <i *ngIf="icon && icon !== ''" [class]="icon"></i>
                {{button}}
            </button>

            <ol *ngIf="!showButton" class="breadcrumb m-0">
                <li class="breadcrumb-item">
                    <a [routerLink]="['/']">{{ 'SIDEBAR.HOME' | translate }}</a>
                </li>
                <ng-container *ngFor="let item of breadcrumbItems">
                    <li class="breadcrumb-item" *ngIf="!item.active">
                        <a (click)="item.path ? router.navigateByUrl(item.path) : null">{{item.label ? (item.label |
                            translate) :
                            null}}</a>
                    </li>
                    <li class="breadcrumb-item active" *ngIf="item.active">
                        <a (click)="item.path ? router.navigateByUrl(item.path) : null">{{item.label ?
                            (item.label | translate) : null}}</a>
                    </li>
                </ng-container>
            </ol>
        </div>

        <h4 class="page-title" >{{title}}</h4>
        <!-- [class]="showButton" -->

    </div>
</div>
<!-- end page title -->